export type yo = '' | 'yes' | 'no';
class CommentedAnswer {
  answer: yo = '';
  comments = '';
}

export default CommentedAnswer;
